import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import OkCancelModal from '@/shared/components/OkCancelModal';
import ToastrService from '@/shared/services/ToastrService';
import { useDisable2FA } from '@/shared/hooks/profile/useDisable2FA';
import messages from '../profileMessages';
const Disable2FAModal = ({ show, onClose }) => {
    const intl = useIntl();
    const { disable2FA } = useDisable2FA();
    const [password, setPassword] = useState('');
    const [dirty, setDirty] = useState(false);
    const formValid = password.length > 0;
    const handleSave = async () => {
        await disable2FA({ password });
        ToastrService.success(intl.formatMessage(messages.TwoFADisabled));
        handleClose();
    };
    const handleClose = () => {
        setPassword('');
        setDirty(false);
        onClose();
    };
    return (_jsx(OkCancelModal, Object.assign({ title: intl.formatMessage(messages.Disable2FA), show: show, onSave: handleSave, onClose: handleClose, disabled: !formValid, okLabel: intl.formatMessage(messages.Disable2FA), zendeskArticle: "6178142418322" }, { children: _jsxs("div", Object.assign({ className: "form-horizontal" }, { children: [_jsx("div", Object.assign({ role: "alert", className: "alert alert-info" }, { children: _jsx("div", { children: intl.formatMessage(messages.Disable2FAWarning) }) })), _jsxs("div", Object.assign({ className: classNames('form-group', {
                        'has-error': dirty && !password,
                    }) }, { children: [_jsx("label", Object.assign({ className: "control-label col-md-2" }, { children: intl.formatMessage(messages.Password) })), _jsxs("div", Object.assign({ className: "col-md-10" }, { children: [_jsx("input", { type: "password", className: "form-control", value: password, onChange: e => {
                                        setPassword(e.target.value);
                                        setDirty(true);
                                    } }), dirty && !password && (_jsx("ul", Object.assign({ className: "help-block" }, { children: _jsx("li", { children: intl.formatMessage(messages.FieldRequired) }) })))] }))] }))] })) })));
};
export default Disable2FAModal;
